import Api from '@/api'

// Open to Work — tradie side (own profile toggle, own incoming requests, own
// dashboard). Company-side OTW state lives in store/modules/candidate.js;
// kept separate since these are two different user types with no overlap.
export default {
  namespaced: true,

  state: {
    profile: null,
    incoming: { resume_requests: [], workforce_invitations: [] },
    dashboardStats: null,
  },

  getters: {
    profile(state) {
      return state.profile
    },
    incoming(state) {
      return state.incoming
    },
    dashboardStats(state) {
      return state.dashboardStats
    },
  },

  mutations: {
    setProfile(state, profile) {
      state.profile = profile
    },
    setIncoming(state, incoming) {
      state.incoming = incoming
    },
    setDashboardStats(state, stats) {
      state.dashboardStats = stats
    },
    setResumeRequestStatus(state, { id, status }) {
      const item = state.incoming.resume_requests.find((r) => r.id === id)
      if (item) item.status = status
    },
    setWorkforceInvitationStatus(state, { id, status }) {
      const item = state.incoming.workforce_invitations.find((i) => i.id === id)
      if (item) item.status = status
    },
  },

  actions: {
    async fetchProfile({ commit }) {
      return new Promise((resolve, reject) => {
        Api.get('tradie/open-to-work')
          .then((res) => {
            const data = (res.data && res.data.data) || res.data
            commit('setProfile', data)
            resolve(data)
          })
          .catch((err) => reject(err.response))
      })
    },

    async updateProfile({ commit }, payload) {
      return new Promise((resolve, reject) => {
        Api.put('tradie/open-to-work', payload)
          .then((res) => {
            const data = (res.data && res.data.data) || res.data
            commit('setProfile', data)
            resolve(data)
          })
          .catch((err) => reject(err.response))
      })
    },

    async fetchIncoming({ commit }) {
      return new Promise((resolve, reject) => {
        Api.get('tradie/open-to-work/requests')
          .then((res) => {
            const data = (res.data && res.data.data) || res.data
            commit('setIncoming', data)
            resolve(data)
          })
          .catch((err) => reject(err.response))
      })
    },

    async fetchDashboardStats({ commit }) {
      return new Promise((resolve, reject) => {
        Api.get('tradie/open-to-work/dashboard')
          .then((res) => {
            const data = (res.data && res.data.data) || res.data
            commit('setDashboardStats', data)
            resolve(data)
          })
          .catch((err) => reject(err.response))
      })
    },

    async respondToResumeRequest({ commit }, { id, status }) {
      return new Promise((resolve, reject) => {
        Api.put(`open-to-work/resume-requests/${id}`, { status })
          .then((res) => {
            commit('setResumeRequestStatus', { id, status })
            resolve((res.data && res.data.data) || res.data)
          })
          .catch((err) => reject(err.response))
      })
    },

    async respondToWorkforceInvitation({ commit }, { id, status }) {
      return new Promise((resolve, reject) => {
        Api.put(`open-to-work/workforce-invitations/${id}`, { status })
          .then((res) => {
            commit('setWorkforceInvitationStatus', { id, status })
            resolve((res.data && res.data.data) || res.data)
          })
          .catch((err) => reject(err.response))
      })
    },
  },
}
